export function reducer(state: number | undefined) {
  return state ?? 0
}
